module.exports = __webpack_public_path__ + "img/接收.f68956fb.svg";